module.exports = __webpack_public_path__ + "static/media/income_.eb7e7121.svg";